<template>
    <section>
    	<!--<header class="mui-bar mui-bar-nav">-->
		    <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
		    <!--<h1 class="mui-title">取样判定-取样</h1>-->
		<!--</header>-->
		<div class="mui-content pd-8">
      <div class="title-name">
        <span class="">取样判定-取样</span>
      </div>
		    <!--基础信息-->
		    <div class="sampling-first" style="margin-top: 15px;">
		        <!--第一行-->
		        <div class="sampling-first-title">
		            <h4>基础信息</h4>
		        </div>
		        <!--第二行内容-->
		        <div class="sampling-first-content">
		            <!--第1行-->
              <div style="font-size: 14px;">
                <div class="sampling-first-content-left">
                  <span>外注订单:</span>
                </div>
                <div class="flex-8">
                  <span>{{paraInfo.ddh}}</span>
                </div>
              </div>
              <!--第2行-->
              <div style="font-size: 14px;">
                <div class="sampling-first-content-left">
                  <span>物料:</span>
                </div>
                <div class="flex-8">
                  <span>{{paraInfo.scxtwph+" "+paraInfo.scxtwpmc}}</span>
                </div>
              </div>
		        </div>
		    </div>
		    <div class="sampling-first" style="border-bottom:0px;">
		        <!--第一行-->
		        <div class="sampling-first-title">
		            <h4>取样信息</h4>
		        </div>
		        <!--第二行内容-->
		        <div class="sampling-first-content">
		        	<div class="form-group">
				    	<label class="input-label">取样时间：</label>
				    	<div class="form-input" style="display: flex;">
				    		<input type="text" style="flex: 6;font-size: 14px;" :data-options='dataoptions' v-model="info.sampletime" @tap="showpicker"/>
				    		<span class="input-label" style="flex:1;">
				    		</span>
				    	</div>
				    </div>
				    <div class="form-group">
				    	<label class="input-label">取样数量：</label>
				    	<div class="form-input" style="display: flex;">
				    		<input style="flex: 6;font-size: 14px;" v-model.number="info.amount" type="number" oninput="if(value.length>8)value=value.slice(0,8)"/>
				    		<span class="input-label" style="flex:1;">
				    			米
				    		</span>
				    	</div>
				    </div>
				    <div class="form-group" style="">
				    	<button type="button" class="mui-btn mui-btn-outlined" style="margin: auto;"@tap="importtsdrollno">从布头标记导入</button>
				    </div>
		        </div>
			    <div class="sampling-first-content">
			        <!--第一个-->
				    <div class="flex-content " style="font-size: 14px;" v-for="item in info.tsdrollnolist">
				    	<div class="flex-box" style="padding-left: 0px;">
				    		<div class="flex-container">
				    			<div class="flex-content-container flex-1">
				    				<div class="flex-content-label" style="text-align: left;min-width: 48px;padding-right: 0px;">机台：</div>
				    				<div class="flex-content-span flex-1" style="padding-left: 0px;">{{item.machineno}}</div>
				    			</div>
                  <div class="flex-content-container flex-1" style="text-align: right;padding-left: 0px;padding-right: 0px;">
                    <div class="flex-content-span" style="padding-left: 0px;">
                      <i :class="[item.changeyarnflg=='1'?'mui-icon mui-icon-checkmarkempty':'mui-icon mui-icon-closeempty']"></i><span>换纱</span>
                      <i :class="[item.clothheadflg=='1'?'mui-icon mui-icon-checkmarkempty':'mui-icon mui-icon-closeempty']"></i><span>布头</span></div>
                  </div>
				    		</div>
				    		<div class="flex-container">
				    			<div class="flex-content-container flex-3">
				    				<div class="flex-content-label" style="text-align: left;">外注卷号:</div>
				    				<div class="flex-content-span flex-1">{{item.wzrollno}}</div>
				    			</div>
				    			<div class="flex-content-container flex-1">

                  </div>
				    		</div>

				    	</div>
				    </div>
					<div class="form-group" style="margin-top: 30px;">
				    	<button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" @tap="save">保存</button>
					</div>	
			    </div>
			 </div>
		</div>
    </section>
</template>

<script>
    import "../../static/js/mui.picker.min.js";
    export default {
        name: "samplingWeavingUpdate",
        data(){
          return{
          	//dataoptions:'{"type":"date"}',
          	dataoptions:'{"type":"datetime"}',// 完整日期视图(年月日时分)
            paraInfo:{ddh:"",wph:"",scxtwph:"" ,scxtwpmc:""},
            info:{ddh:"",wph:"",sampletime:"",amount:0.0,tsdrollnolist:[],location:"4"}
          }
        },
        methods:{
			showpicker(){
				var v=this;
				var dDate = new Date();
				var optionsJson = v.dataoptions;
				var options = JSON.parse(optionsJson);
				var picker = new mui.DtPicker(options);
				picker.show(function (rs) {
					console.log(rs)
					var timestr = rs.text;
					v.info.sampletime=timestr.replace(/-/g,"/");
					picker.dispose();
				});
	       },
		   GetDefalutTime(){
		      // 获取系统时间
		      var systemDate = new Date();
		      var sysTime = "";
		      if (systemDate.getHours() < 10) {
		          sysTime += "0" + systemDate.getHours();
		      } else {
		          sysTime += systemDate.getHours();
		      }
		      if (systemDate.getMinutes() < 10) {
		          sysTime += ":0" + systemDate.getMinutes();
		      } else {
		          sysTime += ":" + systemDate.getMinutes();
		      }
		      return sysTime;
		    },
	        getFormatDate(date) {
		        var seperator1 = "/";
		        var year = date.getFullYear();
		        var month = date.getMonth() + 1;
		        var strDate = date.getDate();
		        if (month >= 1 && month <= 9) {
		            month = "0" + month;
		        }
		        if (strDate >= 0 && strDate <= 9) {
		            strDate = "0" + strDate;
		        }
		        var currentdate = year + seperator1 + month + seperator1 + strDate;
		        return currentdate;
		    },
		    handleInput(e){
  				// 通过正则过滤小数点后两位
  				// 或者 <input v-model.number="age" type="number"> 限制只能输入数字
  				// TODO:
            	e.target.value =(e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null;
		    },
		    importtsdrollno(){
		    	// 从布头标记导入
		    	var v=this;
				v.nyy.doPost("/Sample/getClothInsepctionList",v.paraInfo, 
					function(result){
						if(result.status){
							v.info.tsdrollnolist=result.data.infoLst;
						}
					}
				);
		    },
		    save(){
				var v=this;
				if(v.info.amount==0|| v.info.amount==""){
	               mui.toast("请输入取样数量！");
	               return;
	            }
	            if(!is4SZ(v.info.amount)){
	               mui.toast("请输入合法取样数量！");
	               return;
	            }
	            var str = v.info.amount;    
	            if(str.length!=0){    
	              var reg=/^\d{0,3}(?:\.\d{0,1})?$/;     
	              if(!reg.test(str)){    
	                   mui.toast("格式：999.9！");//请将“整数类型”要换成你要验证的那个属性名称！    
	                  return;
	              }    
	            } 
				if(v.info.tsdrollnolist.length==0){
					 mui.toast("布头明细不存在！");
					 return;
				}
				v.nyy.doPost("/Sample/insertSample",v.info, 
					function(result){
						if(result.status){
							 v.$router.replace({"name":"samplingWeavingHis",params: jsonPara(v.paraInfo)});
						} else {
			                mui.toast(result.message);
			                return;
			            }
					}
				);
		    }
        },
        activated() {
        	var v=this;
          	v.paraInfo = getJsonPara(v.$route);
          	var date = new Date();//获取当前时间
            //var now_date = v.getFormatDate(date);
            var now_date = v.getFormatDate(date) + " " + v.GetDefalutTime();
          	v.info.sampletime=now_date;
          	v.info.ddh=v.paraInfo.ddh;
          	v.info.wph=v.paraInfo.wph;
          	v.info.amount=0.0;
          	v.info.tsdrollnolist=[];
          	v.info.location="4";
        }
    }
</script>

<style scoped>
  @import "../../static/css/mui.picker.min.css";
  @import "../../static/css/sampling.css";
  @import "../../static/css/samplinghistory.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingWeavingUpdate.vue